import {toast} from 'react-toastify';
import api from '../../Interceptor';
import {getRoute} from '../routes';

export const AllExpenses = async ({ userRole, projectId, currencyView }) => {
    try {
        let url = `${getRoute("users", userRole, "expenses", false)}`;
        const params = [];
        if (projectId) {
            params.push(`projectId=${projectId}`);
        }
        if (currencyView) {
            params.push(`currencyView=${currencyView}`);
        }
        if (params.length > 0) {
          url += `?${params.join("&")}`;
        }
        const response = await api.get(url);
        const payload = response?.data;
        return Array.isArray(payload) ? payload : payload?.expenses || [];
    } catch (error) {
        if (error?.isUnpaid) {
      return []; 
    }
        toast.error("Oops! Error while fetching Expenses");
        return [];
    }
};
export const fetchUsersApi = async ({ userRole }) => {
    try {
        const response = await api.get(
            getRoute("users", userRole, "users", false, false, "")
        );
        return response.data;
    } catch (error) {
        if (error?.isUnpaid) {
      return; 
    }
        toast.error("Oops! Error while fetching Users");
    }
};

export const fetchFilteredExpensesApi = async ({
  userRole,
  selectedProject,
  selectedMilestone,
  startDate,
  endDate,
  currencyView,
  includeTotals = false,
}) => {
  try {
    let url = `${getRoute('users', userRole, 'expenses', false)}`;
    let params = [];
    if (selectedProject !== 'All') {
      params.push(`projectId=${selectedProject}`);
    }
    if (selectedMilestone !== 'All') {
      params.push(`milestoneId=${selectedMilestone}`);
    }
    if (startDate) {
      params.push(`startDate=${startDate}`);
    }
    if (endDate) {
      params.push(`endDate=${endDate}`);
    }
    if (currencyView) {
      params.push(`currencyView=${currencyView}`);
    }
    if (params.length > 0) {
      url += `?${params.join('&')}`;
    }
    const response = await api.get(url);
    const payload = response?.data;
    const expenses = Array.isArray(payload) ? payload : payload?.expenses || [];
    if (includeTotals) {
      return {
        expenses,
        totals: payload?.totals || {income: 0, expense: 0, netProfit: 0},
      };
    }
    return expenses;
  } catch (error) {
    if (includeTotals) {
      return {expenses: [], totals: {income: 0, expense: 0, netProfit: 0}};
    }
    return [];
  }
};

export const fetchTransactions = async () => {
  try {
    const response = await api.get(
      getRoute('users', 'admin', 'transaction', false)
      );
    //   const result = await response.data
    return response.data;
  } catch (error) {
    if (error.response && error.response.data) {
      toast.error(
        `Failed to fetch transactions: ${error.response.data.message}`
      );
    } else {
       if (error?.isUnpaid) {
      return; 
    }
      toast.error('An error occurred while fetching transactions.');
    }
    console.error('Fetch transactions error:', error);
  }
};
